import { GetAQuoteWizard } from '@/enterprise/features/extendedNetworkFinance/getAQuote/GetAQuoteWizard';

export const ExtendedNetworkFinanceGetAQuote = () => {
  return <GetAQuoteWizard />;
};
